import { render, staticRenderFns } from "./RoleManagement.vue?vue&type=template&id=b540beca&scoped=true&"
import script from "./RoleManagement.vue?vue&type=script&lang=ts&"
export * from "./RoleManagement.vue?vue&type=script&lang=ts&"
import style0 from "./RoleManagement.vue?vue&type=style&index=0&id=b540beca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b540beca",
  null
  
)

export default component.exports